/* mm-collection: behaviour for the collection area.
   <mm-sort> wraps the sort <select> of sections/mm-collection-grid. Picking an option reloads the page with
   ?sort_by=<value>, keeps every other query parameter (preview, filters, campaign tags) and drops `page`,
   because page 3 of one order is not page 3 of another.
   A custom element, so it starts itself again whenever the theme editor re-renders the section. */
(() => {
  if (customElements.get('mm-sort')) return;

  customElements.define('mm-sort', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.onChange = this.onChange || (() => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
      this.select?.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onChange);
    }
  });
})();
